<div class="c-block c-block--bordered">
  <dl class="c-detail__list">
    <dt class="c-detail__list-name">Solicitor Details</dt>
    <dt class="c-detail__list-title">Have you appointed a solicitor?</dt>
    <dd class="c-detail__list-description">{{InstructSolicitor}}</dd>
  </dl>
  @if (InstructSolicitor ==='Yes') {
    <h5>SolicitorDetails</h5>
    <dl class="c-detail__list">
      <dt class="c-detail__list-title">Name of solicitor</dt>
      <dd class="c-detail__list-description">{{LawyerName}}</dd>
      <dt class="c-detail__list-title">Name of solicitor's firm</dt>
      <dd class="c-detail__list-description">{{SolicitorName}}</dd>
      <dt class="c-detail__list-title">Address</dt>
      <dd class="c-detail__list-description">{{Address}}</dd>
      <dt class="c-detail__list-title">Email address</dt>
      <dd class="c-detail__list-description">{{EmailId}}</dd>
      <dt class="c-detail__list-title">Telephone number</dt>
      <dd class="c-detail__list-description">{{Phone}}</dd>
    </dl>
  }
  @if (showEditButton) {
    <button class="c-button c-button--neutral" type="button" (click)="editButtonClicked()">
      Edit solicitor details
      <svg class=" c-button__icon c-button__icon--right icon-arrow-right " aria-hidden="true " focusable="false " xmlns="http://www.w3.org/2000/svg " viewBox="0 0 8.06 14.71 "><path fill="none " stroke="#2f3432 " stroke-miterlimit="10 " d="M.35 14.35l7-7-7-7 " /></svg>
    </button>
  }
</div>
